import { createNamespacedHelpers } from "vuex";
// Store
const {
  mapActions: mapActionsOfMenu,
  mapMutations: mapMutationsOfMenu,
  mapState: mapStateOfMenu,
  mapGetters: mapGettersOfMenu
} = createNamespacedHelpers("sdfMenu");

export default {
  data() {
    return {};
  },
  computed: {
    ...mapStateOfMenu({
      isShowMenu: state => state.isShowMenu,
      isDisplayOtherVessels: state => state.isDisplayOtherVessels,
      onAlertSummaryNotification: state => state.onAlertSummaryNotification,
      onVesselAutoTracking: state => state.onVesselAutoTracking,
      trackDisplayInterval: state => state.trackDisplayInterval,
      trackHistoryInterval: state => state.trackHistoryInterval,
      showDialogSelectVessel: state => state.showDialogSelectVessel
    }),
    ...mapGettersOfMenu([])
  },
  methods: {
    ...mapActionsOfMenu([
      "setIsDisplayOtherVessels",
      "setOnAlertSummaryNotification",
      "setVesselAutoTracking",
      "setTrackDisplayInterval",
      "setTrackHistoryInterval",
      "setSdfMenuSettings"
    ]),
    ...mapMutationsOfMenu([
      "SET_IS_SHOW_MENU",
      "SET_IS_DISPLAY_OTHER_VESSELS",
      "SET_SHOW_DIALOG_SELECT_VESSEL"
    ])
  }
};
